import { useCallback } from 'react';

// const useDebounce = (callback, delay) => {
//     const debouncedCallback = useCallback(() => {
//         const handler = setTimeout(callback, delay);
//         return () => clearTimeout(handler);
//     }, [callback, delay]);

//     return debouncedCallback;
// };

// export default useDebounce;


const useDebounce = (callback, delay) => {
    const debouncedCallback = useCallback((...args) => {
        const handler = setTimeout(() => {
            callback(...args);  // Ensure the argument is passed to the callback
        }, delay);
        return () => clearTimeout(handler);
    }, [callback, delay]);

    return debouncedCallback;
};

export default useDebounce;